<script lang="ts">
  import type { PicturePanelImageProps } from '$lib/types/layoutTypes';
  import ConditionalWrapper from '$lib/components/control/ConditionalWrapper.svelte';

  export let imageCaption: {
    json: JSON;
  };
  export let mobileImage: PicturePanelImageProps | null;
  export let image: PicturePanelImageProps | null;
  export let url: string;

  export let captionClass = 'text-sm text-gray-600 pt-1';
  export let containerClass = 'py-10 flex flex-col gap-3';
  export let pictureClass = '';
  export let imgClass = 'rounded-xl w-full';
  export let loading = 'lazy';
</script>

<section class={containerClass}>
  <ConditionalWrapper condition={!!url} href={url}>
    <picture class={pictureClass}>
      <source media="(min-width: 640px)" srcset="{image?.url}?w=1200&q=85&fm=webp" />
      {#if mobileImage != null}
        <source media="(max-width: 639px)" srcset="{mobileImage?.url}?w=600&q=85&fm=webp" />
      {/if}
      <img
        src="{image?.url}?fm=webp"
        {loading}
        alt={image?.description || image?.title}
        class={imgClass}
      />
    </picture>
  </ConditionalWrapper>
  {#if imageCaption}
    <p class={captionClass}>{imageCaption}</p>
  {/if}
</section>
